module.exports = __webpack_public_path__ + "static/img/1016_small.da47836.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1016_small.png
// module id = 5Zr+
// module chunks = 1